// PayPal Button Responsive Breakpoints
// Based on official PayPal button specifications

export const MEDIA_QUERIES = {
  // Mobile devices - smallest screens (75px-149px width)
  SMALLEST_MOBILE:
    '@media only screen and (min-width: 75px) and (max-width: 149px)',

  // Small mobile devices (150px-199px width)
  SMALL_MOBILE:
    '@media only screen and (min-width: 150px) and (max-width: 199px)',

  // Medium mobile devices (200px-299px width)
  MEDIUM_MOBILE:
    '@media only screen and (min-width: 200px) and (max-width: 299px)',

  // Large mobile / Small tablet devices (300px-499px width)
  LARGE_MOBILE:
    '@media only screen and (min-width: 300px) and (max-width: 499px)',

  // Desktop / Tablet devices (500px+ width)
  DESKTOP: '@media only screen and (min-width: 500px)',
} as const

// PayPal Button Heights by Breakpoint
export const BUTTON_HEIGHTS = {
  SMALLEST_MOBILE: {
    height: '25px',
    minHeight: '25px',
    maxHeight: '30px',
  },
  SMALL_MOBILE: {
    height: '25px',
    minHeight: '25px',
    maxHeight: '55px',
  },
  MEDIUM_MOBILE: {
    height: '35px',
    minHeight: '35px',
    maxHeight: '55px',
  },
  LARGE_MOBILE: {
    height: '45px',
    minHeight: '30px',
    maxHeight: '55px',
  },
  DESKTOP: {
    height: '55px',
    minHeight: '40px',
    maxHeight: '55px',
  },
} as const

// PayPal Logo Widths by Breakpoint
export const LOGO_WIDTHS = {
  SMALLEST_MOBILE: '50px',
  SMALL_MOBILE: '55px',
  MEDIUM_MOBILE: '65px',
  LARGE_MOBILE: '75px',
  DESKTOP: '80px',
} as const
